import { render, staticRenderFns } from "./BaseMagicIcon.vue?vue&type=template&id=1c67f722"
import script from "./BaseMagicIcon.vue?vue&type=script&lang=js"
export * from "./BaseMagicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports